import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Avatar } from 'shared-components/image/avatar';
import classnames from 'classnames';

const AvatarGroup = ({ className = '', urls = [] }) => {
  return (
    <span className={classnames('AvatarGroup', className)}>
      {
        _.map(urls, (url) => {
          return <Avatar src={url} />;
        })
      }
    </span>
  );
}

AvatarGroup.propTypes = {
  urls: PropTypes.array,
  className: PropTypes.string
};

export default AvatarGroup;
